import { Injectable, signal } from '@angular/core';

export type AppToastSeverity = 'success' | 'info' | 'warn' | 'error';

export interface AppToastMessage {
  id: number;
  severity: AppToastSeverity;
  summary: string;
  detail?: string;
}

/**
 * Shows toasts in the app-level <app-toast> outlet.
 * Holds a single message, so only one toast is ever on screen: a new one replaces the current one.
 */
@Injectable({ providedIn: 'root' })
export class AppToastService {
  private nextId = 0;
  private readonly currentMessage = signal<AppToastMessage | null>(null);

  public readonly message = this.currentMessage.asReadonly();

  public show(severity: AppToastSeverity, summary: string, detail?: string): void {
    this.currentMessage.set({ id: ++this.nextId, severity, summary, detail });
  }

  public showError(summary: string, detail?: string): void {
    this.show('error', summary, detail);
  }

  public dismiss(): void {
    this.currentMessage.set(null);
  }
}
